module.exports = __webpack_public_path__ + "img/title-5.2127405f.png";